export const BENCHMARK_ROUTE_NAME = 'benchmark'
